import { apiFetch } from "./client";

export type DiscountLevel = "CATEGORY" | "PRODUCT";

export type DiscountView = {
  id: string;
  level: DiscountLevel;
  targetId: string;
  targetName: string | null;
  percent: number;
};

export type DiscountUpsert = {
  categoryId?: string | null;
  productId?: string | null;
  percent: number;
};

export const discountsApi = {
  list: (companyId: string) =>
    apiFetch<DiscountView[]>(`/admin/companies/${companyId}/discounts`),
  upsert: (companyId: string, body: DiscountUpsert) =>
    apiFetch<DiscountView>(`/admin/companies/${companyId}/discounts`, { method: "POST", body }),
  remove: (companyId: string, id: string) =>
    apiFetch<void>(`/admin/companies/${companyId}/discounts/${id}`, { method: "DELETE" }),
};
